var _path, _rect, _polygon, _polygon2, _rect2, _polygon3, _path2, _path3, _path4, _polygon4, _polygon5, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _polygon6, _path33, _path34, _polygon7, _path35, _path36, _path37;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMercurioErrorVacio = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 288,
    viewBox: "0 0 346 288",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M321.47,42.57c-17.7-20-46.12-26.91-72.85-28.07-10.83-.47-21.89-.16-32.17,3.28C195.7,24.72,181.15,43.12,162.74,55,127.19,77.79,79.17,75.09,45,99.94a98.42,98.42,0,0,0-22.53,23.32c-24.9,35.68-26.85,85.11-7.84,124.25A136.45,136.45,0,0,0,36.86,280h246c22.1-22.37,37.45-51,47-81.6A280.35,280.35,0,0,0,342.08,120C342.51,92.66,339.51,63.08,321.47,42.57Z",
    fill: "#c6f1e1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 262.67,
    y: 142.03,
    width: 41.39,
    height: 137.97,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "282.61 181.68 324 181.68 304.05 142.03 262.69 142.03 282.61 181.68",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "160.18 181.68 118.81 181.68 145.85 142.03 187.22 142.03 160.18 181.68",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 146.82,
    y: 142.03,
    width: 115.84,
    height: 137.97,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "245.99 183.61 130.13 183.61 146.82 142.03 262.69 142.03 245.99 183.61",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.61,279.66h2.12c-2.93-20.69-5.36-36.9-5.47-37.67l-8.5,10.47C145.05,259.9,149.18,269.33,153.61,279.66Z",
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.56,232.16,81,230.39l-1.12,4.55a53.7,53.7,0,0,0,5.67,39.56l3,5.16h14.18C97,255.22,91.93,233.75,91.56,232.16Z",
    fill: "#262626"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M153.61,279.66c-4.43-10.33-8.56-19.76-11.85-27.2l8.5-10.47h0l-14.8-2.44-43.89-7.38c.37,1.59,5.43,23.06,11.18,47.5Z",
    fill: "#262626"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "116.83 189.09 217.17 183.68 116.83 183.68 116.83 189.09",
    fill: "#262626"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "263 142.14 274.23 184.02 283.76 181.7 263 142.14",
    fill: "#262626"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.63,129s25,21.69,29,63.85l.67,4.25L153,254H77c-.18-6,7.17-48,5.54-61.63-2.6-6.52-10-19.85-10-33.55,0-30.34,27-32.63,27-32.63",
    fill: "#01ffc8",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M311.62,90.7a59.11,59.11,0,0,0-107.83,17.5h0a59.07,59.07,0,0,0,13.44,52.91l-62.86,56.82,4.33,5.55a4.88,4.88,0,0,0,7.22.51l58.39-56.17a58.81,58.81,0,0,0,23.43,11.46,61.15,61.15,0,0,0,6.3,1.14,59.19,59.19,0,0,0,57.59-89.8Zm-2.26,42.42a49.37,49.37,0,1,1-6-37.28A49.37,49.37,0,0,1,309.36,133.12Z",
    fill: "#34806b",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M194.86,198.78c.23,1.19.23,7.28-3.94,9.09l-11.59,4.93s-71.15,32.76-82.72.43c-11.88-32.94-9.26-39.68-9.26-39.68l24.19-7s6.55,37.09,10.19,37.65c20.23,2.84,40.41.71,48.15-1.58.82-.83,6.29-6.92,7.32-8.14s1.86-2.54,2.81-3.64c2.05-2.33,3.61-2.66,4.51-3.57,2.13-2.2,4-.43,2.95.76s-3.17,2.34-5.4,6.93,2.82,3.24,5.68,2.65c3.16-.68,9-4.64,10.74-5.75,1.17-.74.29,3.64-2.17,5.21a46.79,46.79,0,0,1-9.75,4.74",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.86,150.21l6.37,22.35a5.67,5.67,0,0,1-3.57,6.89l-27.74,9.78a4.68,4.68,0,0,1-5.7-2.22c-4.54-8.68-13.66-32.37,1.88-51.86",
    fill: "#01ffc8",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M123.62,105.38v27.83c-1.71,7.1-19.36,3.51-23.77-2.39.17-1.3-.65,1.54-.22-2.13.82-6.86,1.87-15.9,2.33-19.72l.13-1,8.46-1Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M123,108.73v21c-17.86-2.07-21.92-18.57-21.92-18.57l.4-1.51a135.47,135.47,0,0,1,17-1.78A11.3,11.3,0,0,1,123,108.73Z",
    fill: "#262626"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M142.16,94.56c-.24,16.73-11.4,33.79-19.59,31.86C108.73,123.14,98.21,110,98.46,93.26s9.12-28.7,22.82-28.5S142.41,77.83,142.16,94.56Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M128.75,96.1s.45,7.64,3.34,11.41c0,0-2.28,2.8-5,1",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M117.44,94.89c.78,0,1.44,1.11,1.48,2.53s-.56,2.6-1.35,2.62-1.45-1.12-1.49-2.54S116.65,94.91,117.44,94.89Z",
    fill: "#262626"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M137.44,94.89c.78,0,1.44,1.11,1.48,2.53s-.56,2.6-1.35,2.62-1.45-1.12-1.49-2.54S136.65,94.91,137.44,94.89Z",
    fill: "#262626"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M121.7,112.62c-4.65-2.58-6,.66-6,.66",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M121.22,89a19.3,19.3,0,0,0-9.44,1",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M141,90a19.27,19.27,0,0,1-9-3",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M149.36,72.53a5.5,5.5,0,0,1-1.58,2.54c-2.85,2.69-6.74,3.64-10.64,3.85a17.08,17.08,0,0,1-11.06-3.35A11.62,11.62,0,0,1,112.72,79a26.37,26.37,0,0,1-3.63-2,10.77,10.77,0,0,0-1.85,4.49v.27c-.62,3.92-.6,7.87-1.27,11.75s-2.11,7.83-5,10.45c-1.21,1.08-3.33,1.76-4.27.48a3.35,3.35,0,0,1-.45-1.8c-.53-9.45-3.72-14.43-4.08-24.29a13.06,13.06,0,0,1,5-10.16,10.28,10.28,0,0,1,5-2.15h0a4,4,0,0,0,3.13-1.62,25.47,25.47,0,0,0,1.22-3.07,7.82,7.82,0,0,1,2.85-3.46A7.73,7.73,0,0,1,120.05,60a12.47,12.47,0,0,1,5.89-6.12,7,7,0,0,1,4.73-.74,3.82,3.82,0,0,1,3,3.43,12.08,12.08,0,0,1,10-2.26,10.34,10.34,0,0,1,7.43,6.93,9.11,9.11,0,0,1-3,9.54A1.67,1.67,0,0,1,149.36,72.53Z",
    fill: "#262626"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M107.05,96.92a5.9,5.9,0,0,0-1.8-3.27,3.69,3.69,0,0,0-.7-.61,3.74,3.74,0,0,0-2.27-.38,4.8,4.8,0,0,0-2.08.55,3.91,3.91,0,0,0-1.7,2.29,5.19,5.19,0,0,0,.69,4.57,4.35,4.35,0,0,0,4.22,1.69",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M321.47,42.57c-17.7-20-46.12-26.91-72.85-28.07-10.83-.47-21.89-.16-32.17,3.28C195.7,24.72,154.41,20.17,136,32,100.46,54.84,72,55,45,99.94c-5.6,9.33-16.36,14.35-22.53,23.32-24.9,35.68-26.85,85.11-7.84,124.25A136.45,136.45,0,0,0,36.86,280h246c22.1-22.37,37.45-51,47-81.6A280.35,280.35,0,0,0,342.08,120C342.51,92.66,339.51,63.08,321.47,42.57Z",
    fill: "none"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.69,279.83c0,.09,68.82.17,153.7.17s153.71-.08,153.71-.17-68.8-.17-153.71-.17S20.69,279.73,20.69,279.83Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M321.47,42.57c-17.7-20-46.12-26.91-72.85-28.07-10.83-.47-21.89-.16-32.17,3.28C195.7,24.72,181.15,43.12,162.74,55,127.19,77.79,79.17,75.09,45,99.94a98.42,98.42,0,0,0-22.53,23.32c-24.9,35.68-26.85,85.11-7.84,124.25A136.45,136.45,0,0,0,36.86,280h246c22.1-22.37,37.45-51,47-81.6A280.35,280.35,0,0,0,342.08,120C342.51,92.66,339.51,63.08,321.47,42.57Z",
    fill: "none"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M113.27,14.39a11.08,11.08,0,0,1,4.53,8q.75,5.92-2.55,9.24t-9.57,4.13l.52,5.38-4.46.57-1.37-8.89,1.64-.21c3.73-.48,6.57-1.41,8.53-2.81s2.74-3.66,2.34-6.78a7.15,7.15,0,0,0-2.71-5.1,7.59,7.59,0,0,0-5.73-1.28,7.75,7.75,0,0,0-5.26,2.6,6.79,6.79,0,0,0-1.34,5.42L93,25.31a11.59,11.59,0,0,1,.76-6.15,10.42,10.42,0,0,1,3.81-4.53,14.23,14.23,0,0,1,6.28-2.24A13,13,0,0,1,113.27,14.39ZM102.81,52.33A3.41,3.41,0,0,1,101.48,50a3.37,3.37,0,0,1,.7-2.62A3.42,3.42,0,0,1,104.53,46a3.23,3.23,0,0,1,2.53.71,3.65,3.65,0,0,1,.63,5A3.23,3.23,0,0,1,105.42,53,3.42,3.42,0,0,1,102.81,52.33Z",
    fill: "#01ffc8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M78.43,25.57a8.71,8.71,0,0,1,5.92,4.28c1.68,2.67,2.09,5.18,1.24,7.5a12.66,12.66,0,0,1-5.53,6.15l2.16,3.71-3,1.89-3.94-6,1.11-.7a15,15,0,0,0,5.22-4.86c.94-1.65.76-3.54-.57-5.66a5.64,5.64,0,0,0-3.65-2.77,6,6,0,0,0-4.55,1,6.14,6.14,0,0,0-2.93,3.62,5.43,5.43,0,0,0,.83,4.35l-3.29,2a9.14,9.14,0,0,1-1.49-4.68A8.16,8.16,0,0,1,67.18,31,11.26,11.26,0,0,1,71,27.25,10.25,10.25,0,0,1,78.43,25.57Zm5,30.81A2.84,2.84,0,0,1,81.38,53a2.68,2.68,0,0,1,1.25-1.74,2.58,2.58,0,0,1,2.06-.33,2.88,2.88,0,0,1,2.1,3.36A2.57,2.57,0,0,1,85.6,56,2.71,2.71,0,0,1,83.48,56.38Z",
    fill: "#01ffc8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M37.75,224.61s-.21-5.4-2.49-9.14S24.67,209,20.31,210.91A59.58,59.58,0,0,0,13.88,214a49.12,49.12,0,0,1,12.24,5.81A30.78,30.78,0,0,0,37.75,224.61Z",
    fill: "#34806b",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M46.47,227.31s-5-4.78-5.82-11.42,6.23-17,6.23-17a73.28,73.28,0,0,1,5.6,13.91C54.56,220.25,46.47,227.31,46.47,227.31Z",
    fill: "#34806b",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M56,225.23s-1.24-6.23,1-10.59,8.3-3.94,14.32-2.07,7.89,1.87,7.89,1.87a89.83,89.83,0,0,1-13.08,7.26A81.25,81.25,0,0,1,56,225.23Z",
    fill: "#34806b",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M46.52,247.6a.54.54,0,0,1-.54-.54V217.38a.54.54,0,0,1,1.08,0v29.68A.54.54,0,0,1,46.52,247.6Z",
    fill: "#262626",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M49,247.6h-.07a.53.53,0,0,1-.46-.6c.1-.75,2.61-18.33,11.13-28.1a.54.54,0,1,1,.81.71c-8.31,9.52-10.85,27.35-10.88,27.53A.53.53,0,0,1,49,247.6Z",
    fill: "#262626",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M44,247.18h0a.54.54,0,0,1-.53-.54c0-.17.08-17.07-10-25.11a.53.53,0,1,1,.67-.83c10.47,8.37,10.39,25.24,10.38,26A.54.54,0,0,1,44,247.18Z",
    fill: "#262626",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M52.33,247h-.14a.56.56,0,0,1-.38-.66,34.53,34.53,0,0,1,4.86-10.14.54.54,0,1,1,.87.63,33.79,33.79,0,0,0-4.69,9.79A.53.53,0,0,1,52.33,247Z",
    fill: "#262626",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M57.26,236.13s-.21-5.81,2.28-6.64,4.77,1.25,6.64,2.49,3.95,2.49,3.95,6.23a69.66,69.66,0,0,1-1.46,10.58s-2.07-6.43-5.6-9.34S57.26,236.13,57.26,236.13Z",
    fill: "#34806b",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M40.29,247.18a.53.53,0,0,1-.51-.37,19,19,0,0,0-5.42-8.05.52.52,0,0,1-.09-.75.54.54,0,0,1,.75-.09,19.75,19.75,0,0,1,5.78,8.56.54.54,0,0,1-.34.68Z",
    fill: "#262626",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M37.75,240.59s.83-3.74-1.25-6.44-7.06-2.07-9.55.84-6,11.62-6,11.62,5-3.94,10.8-3.94S37.75,240.59,37.75,240.59Z",
    fill: "#34806b",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "55.78 279 36.23 279 26.45 246.65 65.56 246.65 55.78 279",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M194.86,200.62s-5.4,3.09-7.24,3.22",
    fill: "#34806b",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M194.22,203.7s-4.5,2.69-6.35,2.82",
    fill: "#34806b",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "150.26 241.98 150.25 241.98 150.26 241.99 150.26 241.98",
    fill: "#262626"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M193.56,198.69a1.17,1.17,0,0,1,1,2.12",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M193.07,201.72a1.17,1.17,0,0,1,1,2.12",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M191.24,205.31c1.59-.82,2.27.84,1.38,1.4",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMercurioErrorVacio, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mercurio_error_vacio.737d9ff1.svg";
export { ForwardRef as ReactComponent };